import {ChangeDetectionStrategy, Component, input, InputSignal, output, OutputEmitterRef} from "@angular/core";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {TranslateModule} from '@ngx-translate/core';
import {ActivatableDirective} from '../../../ui-elements/activatable.directive';

@Component({
    selector: "woa-field-group",
    templateUrl: "./field-group.component.html",
    styleUrl: "./field-group.component.scss",
    providers: [{provide: NG_VALUE_ACCESSOR, useExisting: FieldGroupComponent, multi: true}],
    imports: [
        TranslateModule,
        ActivatableDirective
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FieldGroupComponent {
    public readonly title: InputSignal<string> = input.required<string>();

    public readonly translationParams: InputSignal<Record<string, string | number>> = input<Record<string, string | number>>({});

    public onActivateTitle: OutputEmitterRef<void> = output<void>();
}
